// extracted by mini-css-extract-plugin
export default {"greeting":"greeting_greeting__K1X7b","dot":"greeting_dot__zwrA6"};